module.exports = __webpack_public_path__ + "static/media/7.657e5bd1.jpg";